import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAlert,{attrs:{"type":"error","value":"true","transition":"scale-transition","dismissible":""}},[_c('h3',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }